<template>
  <div>
    <FiltersWrapper>
      <CollapseBlock class="filters" tablet-mode>
        <div class="filters__item">
          <CustomSelect
            :options="this.residents"
            label="ЖК"
            optionValueKey="resident_id"
            optionLabelKey="resident_name"
            :value="this.filters.resident_id"
            :loading="this.residentsFetching"
            @change="(value) => onFiltersChange('resident_id', value)"
          />
        </div>
        <div class="filters__item">
          <CustomSelect
            :options="this.blocks"
            label="Блок"
            optionValueKey="block_id"
            optionLabelKey="block_name"
            :value="this.filters.block_id"
            :loading="this.blocksFetching"
            :disabled="!this.filters.resident_id"
            @change="(value) => onFiltersChange('block_id', value)"
          />
        </div>
        <div class="filters__item">
          <CustomSelect
            :options="this.workGroupDicts"
            label="Тип Конструктива"
            optionValueKey="work_group_dict_id"
            optionLabelKey="work_group_name"
            :value="this.filters.work_group_dict_id"
            :loading="this.workGroupDictsFetching"
            @change="(value) => onFiltersChange('work_group_dict_id', value)"
          />
        </div>
      </CollapseBlock>
    </FiltersWrapper>
    <div class="date-selector-container">
      <q-btn
        icon="chevron_left"
        flat
        dense
        round
        @click="goToPreviousDay"
        class="date-nav-btn"
      />
      <q-input
        v-model="selectedDate"
        type="date"
        outlined
        dense
        class="date-input"
        @update:model-value="onDateChange"
        mask="####-##-##"
      />
      <q-btn
        icon="chevron_right"
        flat
        dense
        round
        @click="goToNextDay"
        class="date-nav-btn"
      />
    </div>
    <div class="data-container">
      <div v-if="isFetching" class="loading-container">
        <q-spinner color="primary" size="3em" />
      </div>
      <div v-else-if="!groupedData || groupedData.length === 0" class="empty-container">
        <div v-if="rawData && rawData.length > 0">
          Данные пришли ({{ rawData.length }} записей), но не сгруппировались. Проверьте консоль браузера.
        </div>
        <div v-else>
          Нет данных за выбранную дату
        </div>
      </div>
      <div v-else class="nested-list">
        <div
          v-for="resident in groupedData"
          :key="`resident-${resident.resident_id}`"
          class="nested-item resident-item"
        >
          <div 
            class="nested-item-header"
            @click="toggleResident(resident.resident_id)"
          >
            <q-icon 
              :name="expandedResidents[resident.resident_id] ? 'expand_more' : 'chevron_right'" 
              class="expand-icon" 
            />
            <q-icon name="home" class="item-icon" />
            <span class="item-title">{{ resident.resident_name }}</span>
          </div>
          <div 
            v-show="expandedResidents[resident.resident_id]"
            class="nested-children"
          >
            <div
              v-for="block in resident.blocks"
              :key="`block-${block.block_id}`"
              class="nested-item block-item"
            >
              <div 
                class="nested-item-header"
                @click="toggleBlock(resident.resident_id, block.block_id)"
              >
                <q-icon 
                  :name="expandedBlocks[`${resident.resident_id}-${block.block_id}`] ? 'expand_more' : 'chevron_right'" 
                  class="expand-icon" 
                />
                <q-icon name="business" class="item-icon" />
                <span class="item-title">{{ block.block_name }}</span>
              </div>
              <div 
                v-show="expandedBlocks[`${resident.resident_id}-${block.block_id}`]"
                class="nested-children"
              >
                <div
                  v-for="workGroup in block.work_groups"
                  :key="`workgroup-${getWorkGroupKey(resident.resident_id, block.block_id, workGroup.work_group_id, workGroup.work_group_dict_id, workGroup.work_group_name)}`"
                  class="nested-item workgroup-item"
                >
                  <div 
                    class="nested-item-header"
                    @click="toggleWorkGroup(resident.resident_id, block.block_id, workGroup.work_group_id, workGroup.work_group_dict_id, workGroup.work_group_name)"
                  >
                    <q-icon 
                      :name="expandedWorkGroups[getWorkGroupKey(resident.resident_id, block.block_id, workGroup.work_group_id, workGroup.work_group_dict_id, workGroup.work_group_name)] ? 'expand_more' : 'chevron_right'" 
                      class="expand-icon" 
                    />
                    <q-icon name="construction" class="item-icon" />
                    <span class="item-title">{{ workGroup.work_group_name }}</span>
                  </div>
                  <div 
                    v-show="expandedWorkGroups[getWorkGroupKey(resident.resident_id, block.block_id, workGroup.work_group_id, workGroup.work_group_dict_id, workGroup.work_group_name)]"
                    class="nested-children"
                  >
                    <div
                      v-for="task in workGroup.tasks"
                      :key="`task-${task.task_dict_id}`"
                      class="task-item"
                    >
                      <div class="task-info">
                        <span class="task-name">{{ task.task_name }}</span>
                        <span v-if="task.unit_name" class="task-unit">({{ task.unit_name }})</span>
                      </div>
                      <div class="task-values">
                        <q-btn
                          v-if="task.plan_value !== null && task.plan_value !== undefined && task.plan_value !== ''"
                          :label="task.plan_value"
                          dense
                          size="sm"
                          class="plan-value-btn"
                        />
                        <q-btn
                          v-if="task.fact_value !== null && task.fact_value !== undefined && task.fact_value !== ''"
                          :label="task.fact_value"
                          dense
                          size="sm"
                          class="fact-value-btn"
                          :style="{ backgroundColor: task.color || '#1976d2' }"
                        />
                        <span
                          v-if="(!task.plan_value || task.plan_value === '') && (!task.fact_value || task.fact_value === '')"
                          class="text-grey-5"
                        >
                          -
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CollapseBlock from "@/components/common/CollapseBlock";
import FiltersWrapper from "@/components/common/FiltersWrapper";
import { getResidents, getBlocks, getWorkGroupDicts, getWorkTaskFactDaily } from "./services";

export default {
  name: "TierDaily",
  components: { CustomSelect, CollapseBlock, FiltersWrapper },
  data() {
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0]; // Формат YYYY-MM-DD
    
    return {
      residents: [],
      blocks: [],
      workGroupDicts: [],
      residentsFetching: false,
      blocksFetching: false,
      workGroupDictsFetching: false,
      selectedDate: todayStr,
      isFetching: false,
      groupedData: [],
      rawData: [], // Для отладки
      expandedResidents: {}, // Раскрытые ЖК: { resident_id: true }
      expandedBlocks: {}, // Раскрытые блоки: { 'resident_id-block_id': true }
      expandedWorkGroups: {}, // Раскрытые конструктивы: { 'resident_id-block_id-work_group_dict_id': true }
      filters: {
        resident_id: '',
        block_id: '',
        work_group_dict_id: '',
      },
    }
  },
  mounted() {
    this.loadResidents();
    this.loadWorkGroupDicts();
    this.loadDailyData();
  },
  watch: {
    selectedDate() {
      this.loadDailyData();
    },
    'filters.resident_id'() {
      this.loadDailyData();
    },
    'filters.block_id'() {
      this.loadDailyData();
    },
    'filters.work_group_dict_id'() {
      this.loadDailyData();
    },
  },
  methods: {
    async loadResidents() {
      this.residentsFetching = true;
      const res = await getResidents();
      this.residentsFetching = false;
      this.residents = res || [];
    },
    async loadBlocks(resident_id) {
      if (!resident_id) {
        this.blocks = [];
        return;
      }
      this.blocksFetching = true;
      const res = await getBlocks(resident_id);
      this.blocksFetching = false;
      this.blocks = res || [];
    },
    async loadWorkGroupDicts() {
      this.workGroupDictsFetching = true;
      const res = await getWorkGroupDicts();
      this.workGroupDictsFetching = false;
      this.workGroupDicts = res || [];
    },
    async loadDailyData() {
      if (!this.selectedDate) return;
      
      // Преобразуем дату из YYYY-MM-DD в DD.MM.YYYY для API
      const dateParts = this.selectedDate.split('-');
      const formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
      
      this.isFetching = true;
      try {
        // Бэкенд уже возвращает данные в сгруппированном виде
        const data = await getWorkTaskFactDaily(
          formattedDate,
          this.filters.resident_id || null,
          this.filters.block_id || null,
          this.filters.work_group_dict_id || null
        );
        this.rawData = data || [];
        this.groupedData = data || [];
      } catch (e) {
        console.error('Error loading daily data:', e);
        this.groupedData = [];
      } finally {
        this.isFetching = false;
      }
    },
    onFiltersChange(key, value) {
      const editedObject = {
        [key]: value,
      };

      if (key === 'resident_id') {
        editedObject.block_id = '';
        if (!!value) {
          this.loadBlocks(value);
        } else {
          this.blocks = [];
        }
      }

      this.filters = {
        ...this.filters,
        ...editedObject,
      };
    },
    onDateChange() {
      this.loadDailyData();
    },
    goToPreviousDay() {
      const currentDate = new Date(this.selectedDate);
      currentDate.setDate(currentDate.getDate() - 1);
      this.selectedDate = currentDate.toISOString().split('T')[0];
      this.onDateChange();
    },
    goToNextDay() {
      const currentDate = new Date(this.selectedDate);
      currentDate.setDate(currentDate.getDate() + 1);
      this.selectedDate = currentDate.toISOString().split('T')[0];
      this.onDateChange();
    },
    toggleResident(residentId) {
      const isCurrentlyExpanded = this.expandedResidents[residentId];
      // Если открываем этот ЖК, закрываем все остальные
      if (!isCurrentlyExpanded) {
        this.expandedResidents = {
          [residentId]: true
        };
        // Также закрываем все блоки и конструктивы
        this.expandedBlocks = {};
        this.expandedWorkGroups = {};
      } else {
        // Если закрываем, просто закрываем этот ЖК
        this.expandedResidents = {
          ...this.expandedResidents,
          [residentId]: false
        };
      }
    },
    toggleBlock(residentId, blockId) {
      const key = `${residentId}-${blockId}`;
      const isCurrentlyExpanded = this.expandedBlocks[key];
      
      // Если открываем этот блок, закрываем все остальные блоки в этом ЖК
      if (!isCurrentlyExpanded) {
        // Закрываем все блоки в этом ЖК
        const newExpandedBlocks = {};
        Object.keys(this.expandedBlocks).forEach(blockKey => {
          if (!blockKey.startsWith(`${residentId}-`)) {
            newExpandedBlocks[blockKey] = this.expandedBlocks[blockKey];
          }
        });
        newExpandedBlocks[key] = true;
        this.expandedBlocks = newExpandedBlocks;
        
        // Закрываем все конструктивы в этом ЖК
        const newExpandedWorkGroups = {};
        Object.keys(this.expandedWorkGroups).forEach(workGroupKey => {
          if (!workGroupKey.startsWith(`${residentId}-`)) {
            newExpandedWorkGroups[workGroupKey] = this.expandedWorkGroups[workGroupKey];
          }
        });
        this.expandedWorkGroups = newExpandedWorkGroups;
      } else {
        // Если закрываем, просто закрываем этот блок
        this.expandedBlocks = {
          ...this.expandedBlocks,
          [key]: false
        };
      }
    },
    getWorkGroupKey(residentId, blockId, workGroupId, workGroupDictId, workGroupName) {
      // Используем тот же алгоритм, что и в группировке
      // КРИТИЧНО: Приоритет у work_group_id, если он есть
      let workGroupKeyPart;
      
      if (workGroupId !== null && workGroupId !== undefined && workGroupId !== '') {
        // Приоритет: work_group_id - это конкретная группа работ, уникальная для каждого конструктива
        workGroupKeyPart = `wg_${workGroupId}`;
      } else {
        // Если work_group_id нет, используем комбинацию work_group_dict_id + work_group_name
        const normalizedWorkGroupName = (workGroupName || '').trim();
        
        if (workGroupDictId !== null && workGroupDictId !== undefined && workGroupDictId !== '') {
          // Используем комбинацию work_group_dict_id и work_group_name
          workGroupKeyPart = `wgd_${workGroupDictId}_${normalizedWorkGroupName}`;
        } else {
          // Если нет ни того, ни другого, используем только название
          workGroupKeyPart = `name_${normalizedWorkGroupName}`;
        }
      }
      
      return `${residentId}-${blockId}-${workGroupKeyPart}`;
    },
    toggleWorkGroup(residentId, blockId, workGroupId, workGroupDictId, workGroupName) {
      const key = this.getWorkGroupKey(residentId, blockId, workGroupId, workGroupDictId, workGroupName);
      this.expandedWorkGroups = {
        ...this.expandedWorkGroups,
        [key]: !this.expandedWorkGroups[key]
      };
    },
  },
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 25px;
  max-width: 500px;

  &__item {
    min-width: 150px;
  }
}

.date-selector-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;

  .date-nav-btn {
    min-width: 40px;
    width: 40px;
    height: 40px;
  }

  .date-input {
    flex: 0 0 auto;
    min-width: 150px;
  }
}

.data-container {
  width: 100%;
}

.loading-container,
.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #666;
}

.nested-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nested-item {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 2px;
  
  &.resident-item {
    background-color: #f8f9fa;
  }
  
  &.block-item {
    background-color: #ffffff;
    margin-left: 0;
    border-left: 3px solid #1976d2;
  }
  
  &.workgroup-item {
    background-color: #ffffff;
    margin-left: 0;
    border-left: 3px solid #4caf50;
  }
}

.nested-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
  border-bottom: 1px solid transparent;
  
  &:hover {
    background-color: #f0f0f0;
  }
  
  .expand-icon {
    font-size: 20px;
    color: #666;
    transition: transform 0.2s;
    min-width: 24px;
  }
  
  .item-icon {
    font-size: 20px;
    color: #1976d2;
  }
  
  .item-title {
    font-size: 16px;
    flex: 1;
  }
}

.nested-children {
  padding: 0;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
}

.task-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px 10px 48px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #ffffff;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  .task-info {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    
    .task-name {
      font-weight: 500;
    }
    
    .task-unit {
      color: #666;
      font-size: 14px;
    }
  }
  
  .task-values {
    display: flex;
    gap: 4px;
    align-items: center;
  }
}

.plan-value-btn {
  min-width: auto;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  background-color: #1976d2;
  color: white;
  
  &:hover {
    background-color: #1565c0;
  }
}

.fact-value-btn {
  min-width: auto;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  color: white;
  
  &:hover {
    opacity: 0.9;
  }
}
</style>

